<template>
    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Sortennummer</th>
                    <th scope="col">Bezeichnung</th>
                    <th scope="col"><abbr title="Mengeneinheit">ME</abbr></th>
                    <th scope="col">Preis</th>
                    <th scope="col">Standorte</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in filteredProducts" :key="product.id">
                    <td>{{ product.sortNumber }}</td>
                    <td>{{ product.name }}</td>
                    <td>{{ product.unit }}</td>
                    <td>
                        <div
                            class="vstack gap-1 text-nowrap"
                            v-if="product.priceNet"
                        >
                            <span>
                                {{ formatPrice(product.priceNet) }}
                                Netto
                            </span>
                            <span>
                                {{ formatPrice(product.priceGross) }}
                                Brutto
                            </span>
                        </div>
                        <template v-else>Auf Anfrage</template>
                    </td>
                    <td>
                        <div class="d-flex flex-wrap gap-1">
                            <button
                                v-for="location in getFilteredLocations(
                                    product.locations
                                )"
                                :key="location.id"
                                type="button"
                                :class="
                                    location.certified
                                        ? 'location-badge'
                                        : 'location-badge-outline'
                                "
                                style="cursor: pointer"
                                data-bs-toggle="modal"
                                :data-bs-target="`#location-modal-${location.id}`"
                            >
                                <span>{{ location.name }}</span>
                                <ui-icon
                                    v-if="location.certified"
                                    icon="check"
                                    size="16"
                                ></ui-icon>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    products: {
        type: Array,
        required: true,
    },
    showStandard: {
        type: Boolean,
        default: true,
    },
    showCertified: {
        type: Boolean,
        default: true,
    },
});

const getFilteredLocations = (locations) => {
    if (!locations) return [];
    return locations.filter((loc) => {
        if (loc.certified && !props.showCertified) return false;
        if (!loc.certified && !props.showStandard) return false;
        return true;
    });
};

// Only show products that have at least one matching location
const filteredProducts = computed(() => {
    return props.products.filter((product) => {
        const visibleLocations = getFilteredLocations(product.locations);
        return visibleLocations.length > 0;
    });
});

const formatPrice = (price) => {
    if (price == null) return '-';
    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    }).format(price);
};

</script>
